import React, { forwardRef, Suspense, lazy, } from "react";
import { Spin } from 'antd';
import { getQuizName } from 'lib';
import MultiChoiceGridTile from './MultiChoiceGridTile';
import MultiChoiceGridBasic from './MultiChoiceGridBasic';

export default forwardRef((props: any, ref: any) => {
  const quizName = getQuizName();

  return (
    <>
      {
        quizName && quizName.includes('China Quiz') ?
        <MultiChoiceGridTile {...props} /> :
        <MultiChoiceGridBasic {...props} />
      }
    </>
  )
});
